import * as React from "react";
import { useState } from "react";
import { useEffect } from "react";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import {
  Box,
  Stack,
  MenuItem,
  ListItemText,
  ListItemButton,
  Typography,
  Divider,
  TextField,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import HourglassTopTwoToneIcon from "@mui/icons-material/HourglassTopTwoTone";
import ReportDialog from "./ReportDialog";
import AssignDialog from "./AssignDialog";
import { allApis } from "../../request/config";
import { ObjectValues } from "../login";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  fetchReportedQuestions,
  fetchReportedQuestionsCount,
  fetchReportedBy,
  assignStaff,
} from "../../store/slices/contentFeedback/contentFeedbackSlice";
import { useAppDispatch } from "../../hooks/storeHooks";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { headerContent } from "../../Components/CustomTexts";
import globalColors from "../../globalColors";
import CustomTab from "../../Components/CustomTab";
import mathFunction from "../exams/mathFunction";
import { debounce } from "lodash";
import ConfirmationDialog from "../../Components/ConfirmationDialog";
import GlobalBackdrop from "./GlobalBackdrop";
import FilterPanel from "./FilterPanel";
import CustomPopover from "../../Components/CustomPopover";
import { moreRound } from "../../assets/svgs";
import { CustomListItem } from "../../Components/CustemListItem";
import CustomContainedButton from "../../Components/CustomContainedButton";
import MessagePopper from "./MessagePopper";
import { getServerEnvironment } from "../../store/slices/constants/staticContents";
import DataTable from "./DataTable";
import ReportedQuestionPreview from "./ReportedQuestionPreview";
import ReportedDetailsExpand from "./ReportedDetails/ReportedDetailsExpand";

const ContentFeedback: React.FC = () => {
  const [value, setValue] = useState(0);
  const [openReportDialog, setOpenReportDialog] = useState<
    false | ObjectValues
  >(false);
  const [openAssignDialog, setOpenAssignDialog] = useState(false);

  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [editScreenId, setEditScreenId] = useState<any | null>(null);
  const [reviewStatus, setReviewStatus] = useState("pending"); // Initial status
  const [selectedStaff, setSelectedStaff] = useState<any | null>(null);
  const [loadingInitial, setLoading] = useState(true);
  const [openComfirm, setConfirmation] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [dialogs, setDialog] = useState<ObjectValues>({});

  const {
    reportedQuestions,
    reportedQuestionsCount,
    countLoading,
    staffList,
    loading,
    masters,
  } = useSelector((state: RootState) => state.contentFeedback);
  const dFilter = {
    exam: "",
    exam_id: "",
    goal: "",
    goal_id: "",
    section: "",
    section_id: "",
    reported_by: "",
    reported_by_id: "",
    reviewed_by: "",
    reviewed_by_id: "",
    staff: "",
    staff_id: "",
    duration: "",
    duration_id: "",
    sort_by: undefined as undefined | string,
    sort_by_type: undefined as undefined | string,
    start_date: null as Date | null,
    end_date: null as Date | null,
    refetch: false as boolean,
    onlyFetchTable: false as boolean,
  };
  const [pages, setPages] = useState(1);

  const [serach, setSearch] = useState("");
  const localFiltersValues = localStorage.getItem(
    btoa(`content-feedback-filters-${getServerEnvironment()}`)
  );
  const [filters, setFilters] = useState(
    localFiltersValues && localFiltersValues !== undefined
      ? JSON.parse(atob(localFiltersValues))
      : dFilter
  );

  const getCount = (id: string) => allApis?.reportQuestionCount(id);
  const dispatch = useAppDispatch();

  const handleDialogOpen = (row: any) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  // Function to close dialog
  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };
  const globalLoading = useSelector(
    (state: RootState) => state.contentFeedback.loadingCount > 0
  );
  // const questionPreviewData = useAppSelecter(
  //   (state: RootState) => state.contentFeedback.questionEditData
  // );

  const navigate = useNavigate();

  useEffect(() => {
    const previousUrl = window.location.href;
    localStorage.setItem("previousUrl", previousUrl);
  }, []);

  useEffect(() => {
    Promise.all([
      dispatch(
        fetchReportedQuestionsCount({
          api: getCount(
            `?exam=${
            filters.exam ? filters.exam_id : ""
          }&goal=${filters.goal ? filters.goal_id : ""}&section=${
              filters.section ? filters.section_id : ""
            }&duration=${
              filters.duration ? filters.duration_id : ""
            }&reviewed_by=${
              filters.reviewed_by ? filters.reviewed_by_id : ""
            }&reported_by=${
              filters.reported_by ? filters.reported_by_id : ""
            }&${
              filters.duration_id === "custom"
                ? `start_date=${moment(filters.start_date).format(
                    "YYYY-MM-DD"
                  )}&end_date=${moment(filters.end_date).format("YYYY-MM-DD")}&`
                : ""
            }`
          ),
        })
      ).unwrap(),
      localStorage.setItem(
        btoa(`content-feedback-filters-${getServerEnvironment()}`),
        btoa(JSON.stringify(filters))
      ),
    ]).finally(() => setLoading(false));
  }, [
    dispatch,
    reviewStatus,
     filters.exam_id,
    filters.goal_id,
    filters.section_id,
    filters.duration_id,
    filters.reviewed_by_id,
    filters.reported_by_id,
    filters.duration_id,
    filters.refetch,
  ]);

  useEffect(() => {
    Promise.all([
      dispatch(
        fetchReportedQuestions({
          state: `${reviewStatus}&exam=${
            filters.exam ? filters.exam_id : ""
          }&goal=${
            filters.goal ? filters.goal_id : ""
          }&section=${filters.section ? filters.section_id : ""}&duration=${
            filters.duration ? filters.duration_id : ""
          }&reviewed_by=${
            filters.reviewed_by ? filters.reviewed_by_id : ""
          }&reported_by=${filters.reported_by ? filters.reported_by_id : ""}${
            filters.sort_by
              ? `&ordering=${filters.sort_by_type === "-" ? "-" : ""}${
                  filters.sort_by
                }`
              : reviewStatus === "pending"
              ? "&ordering=-reported_at"
              : "&ordering=-modified_at"
          }&${
            filters.duration_id === "custom"
              ? `start_date=${moment(filters.start_date).format(
                  "YYYY-MM-DD"
                )}&end_date=${moment(filters.end_date).format("YYYY-MM-DD")}&`
              : ""
          }`,
          page: pages ? pages : 0,
        })
      ).unwrap(),
    ]).finally(() => setLoading(false));
  }, [
    dispatch,
    reviewStatus,
    pages,
    filters.exam_id,
    filters.goal_id,
    filters.section_id,
    filters.duration_id,
    filters.reviewed_by_id,
    filters.reported_by_id,
    filters.duration_id,
    filters.sort_by,
    filters.sort_by_type,
    filters.refetch,
    filters.onlyFetchTable,
  ]);

  const formatDateRange = (range: {
    startDate: Date | null;
    endDate: Date | null;
  }) => {
    const formatDate = (date: Date | null) => {
      if (!date) return "";
      if (date && date.getDate) {
        const day = date.getDate();
        const month = date.toLocaleString("default", { month: "2-digit" }); // Get the full month name
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
    };

    const start = range.startDate ? formatDate(new Date(range.startDate)) : "";
    const end = range.endDate ? formatDate(new Date(range.endDate)) : "";
    return start && end ? `${start} - ${end}` : "";
  };

  useEffect(() => {
    if (localStorage.getItem(btoa(`p-r-p-${getServerEnvironment()}`))) {
      setPages(
        parseInt(
          localStorage.getItem(btoa(`p-r-p-${getServerEnvironment()}`)) ?? "1"
        )
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (masters.exams && masters.exams.length === 1) {
      setFilters((prev: any) => ({
        ...prev,
        exam: masters.exams[0].name,
        exam_id: masters.exams[0].id,
      }));
    }
  }, [dispatch, masters.exams]);

  const handleStaffChange = (event: any, newValue: any) => {
    setSelectedStaff(newValue);
  };

  useEffect(() => {
    mathFunction();
  }, [value, openDialog]);
  const handleShowReport = (report: ObjectValues) => {
    setOpenReportDialog(report);
  };

  const handleCloseDialog = () => {
    setOpenReportDialog(false);
  };

  // Update the review status based on the selected tab
  const handleChange = (newValue: number) => {
    // dispatch(clearListData()); // Clear the list data
    // dispatch(clearReportData()); // Clear the report data
    setValue(newValue);

    if (newValue === 0) {
      setReviewStatus("pending");
    } else if (newValue === 1) {
      setReviewStatus("under_review");
    } else if (newValue === 2) {
      setReviewStatus("reviewed");
    }
    if (newValue === 3) {
      setReviewStatus("archived");
    }
    onPageChange(1);
  };

  const handleAssign = ({ row }: any) => {
    setSelectedRow(row);
    setOpenAssignDialog(true);
  };

  const handleCloseAssignDialog = () => {
    handleStaffChange(null, null);
    setOpenAssignDialog(false);
  };
  const handleConfirmAssign = (assignee: any) => {};

  useEffect(() => {
    if (editScreenId !== null) {
      localStorage.setItem(
        btoa(`cf-lists-${getServerEnvironment()}`),
        btoa(
          JSON.stringify({
            quelist: (reportedQuestions.results ?? []).map((s: { id: any; question: any; }) => {
              return { id: s.id, que: s.question };
            }),
          })
        )
      );
      const url = `${
        window.location.origin
      }/contentFeedback/editScreen/${editScreenId}/${selectedRow?.id ?? ""}`;
      window.open(url, "_blank", "noopener,noreferrer");
      setEditScreenId(null);
      setConfirmation(true);
    }
  }, [editScreenId, selectedRow, navigate]);

  const handleReview = (id: number, row: any) => {
    setEditScreenId(id);
    setSelectedRow(row);
  };

  function stripHtmlTags(html: any) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }
  const sanitizedReportedQuestions =
    reportedQuestions && reportedQuestions.results
      ? reportedQuestions.results.map((question: { question_text: any }) => ({
          ...question,
          question_text: stripHtmlTags(question.question_text),
        }))
      : [];
  const onPageChange = (page: any) => {
    setPages(page.pageSize ? page.page ?? 1 : page);
    localStorage.setItem(
      btoa(`p-r-p-${getServerEnvironment()}`),
      (page.page ? page.page : page).toString()
    );
    setLoading(true);
  };

  const cellFlexColumn: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
  };

  const columns = (state: string): GridColDef[] => [
    {
      headerName: "Last Reported Time",
      field: "reported_at",
      width: 156,
      sortable: true,
      renderCell: ({ row }) => (
        <div>
          {moment(row.reported_at).format("Do MMM YYYY")}
          <br />
          {moment(row.reported_at).format("hh:mm A")}
        </div>
      ),
    },
    {
      field: "report_source",
      headerName: "Report Source",
      sortable: false,
      width: 124,
      renderCell: ({ row }) =>
        row.report_source ? (
          <Box
            sx={{
              bgcolor: "#f3e8ff",
              borderRadius: "5px",
              padding: "3px 10px",
              color: "#6b21a8",
            }}
          >
            {row.report_source}
          </Box>
        ) : (
          "N/A"
        ),
    },
    {
      field: "goal_name",
      headerName: "Goal",
      sortable: true,
      width: 110,
      renderCell: ({ row }) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {row.goal && (
            <Box>
              {row.goal?.name ?? ""}
              <br />
              <span style={{ color: "#6b7280" }}>{`(#${
                row.goal?.id ?? ""
              })`}</span>
            </Box>
          )}
        </div>
      ),
    },
    {
      field: "section",
      headerName: "Section",
      sortable: true,
      width: 200,
      renderCell: ({ row }) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {row.section && (
            <Box>
              {row.section?.name ?? ""}
              <br />
              <span style={{ color: "#6b7280" }}>{`(#${
                row.section?.id ?? ""
              })`}</span>
            </Box>
          )}
        </div>
      ),
    },
    {
      field: "topic",
      headerName: "Topic",
      sortable: true,
      width: 200,
      renderCell: ({ row }) =>
        row.topic ? (
          <div style={cellFlexColumn}>
            <Box>
              {row.topic?.name ?? ""}
              <br />
              <span style={{ color: "#6b7280" }}>{`(#${
                row.topic?.id ?? ""
              })`}</span>
            </Box>
            {row.is_free && (
              <Box
                sx={{
                  bgcolor: "#ecfdf5",
                  borderRadius: "5px",
                  padding: "3px 10px",
                  color: globalColors.primary.green,
                  width: "fit-content",
                  mt: 1,
                }}
              >
                Free
              </Box>
            )}
          </div>
        ) : (
          <></>
        ),
    },
    {
      field: "subtopic",
      headerName: "Subtopic",
      sortable: true,
      width: 200,
      renderCell: ({ row }) => (
        <div style={cellFlexColumn}>
          {row.subtopic && (
            <Box>
              {row.subtopic?.name ?? ""}
              <br />
              <span style={{ color: "#6b7280" }}>{`(#${
                row.subtopic?.id ?? ""
              })`}</span>
            </Box>
          )}
        </div>
      ),
    },
    {
      field: "question_text",
      headerName: "Question Text",
      width: 250,
      sortable: false,
      renderCell: ({ row }) => (
        <div
          style={{
            maxHeight: "fit-content",
            // overflow: "hidden",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleDialogOpen(row);
          }}
        >
          {/* <ToolTipComp question_text={row.question_text ?? ""} /> */}
          <div style={{ minHeight: "59.99px" }}>
            {" "}
            <div style={{ height: "35px" }}>
              <MessagePopper
                text={row.question_text ?? ""}
                type="ck"
                id={"question"}
              />
            </div>
          </div>

          <div style={{ color: "#6b7280", width: "100%", marginTop: "5px" }}>
            {`(#${row.question ?? ""})`}
          </div>
        </div>
      ),
    },
    {
      field: "question_created_by",
      headerName: "Que. Created By",
      width: 140,
      renderCell: ({ row }) => row.question_created_by ?? "",
    },
    {
      field: "reported_contents",
      headerName: "Reported Contents",
      width: 244,
      sortable: false,
      renderCell: ({ row }: any) => (
        <Box display="flex" flexDirection="column" gap={0.5}>
          {/* Content */}
          <Box>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              Content:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {row.reported_contents || "-"}
            </Typography>
          </Box>

          {/* Remark (only if exists) */}
          {row.validator_remark && (
            <Box>
              <Typography variant="body2" fontWeight={500} color="text.primary">
                Remark:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {row.validator_remark}
              </Typography>
            </Box>
          )}
        </Box>
      ),
    },
    {
      field: "total_reports",
      headerName: "Reported Count",
      width: 120,
      sortable: false,
      renderCell: ({ row }) => (
        <Box
          onClick={(e) => {
            e.stopPropagation();
            handleShowReport(row);
          }}
          sx={{
            borderRadius: "50%",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            width: "25px",
            height: "25px",
            cursor: "pointer",
          }}
        >
          <span
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "#2563eb",
            }}
          >
            {row?.total_reports}
          </span>
        </Box>
      ),
    },
    {
      field: "reported_by",
      headerName: "Reported By",
      sortable: true,
      width: 200,
      renderCell: ({ row }: any) => {
        const renderDate = (date: string) =>
          date ? moment(date).format("Do MMM YYYY, hh:mm A") : "";

        return (
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* Reviewed Info */}
            {row.reported_by && (
              <Box sx={{ width: "100%" }}>
                <strong>{row.reported_by.full_name}</strong>

                <Box sx={{ width: "100%" }}>{row.reported_by.phone}</Box>
                <div
                  style={{ color: "#6b7280", width: "100%", marginTop: "5px" }}
                >
                  {`#${row.reported_by.id}`}
                </div>
              </Box>
            )}
          </Box>
        );
      },
    },
    {
      field: "reviewed_before",
      headerName: "Reviewed Before",
      sortable: false,
      width: 126,
      renderCell: ({ row }) => (
        <Box
          sx={{
            color: "#1f2937",
            bgcolor: "#f3f4f6",
            borderRadius: "5px",
            padding: "3px 10px",
            width: "fit-content",
          }}
        >
          {row.reviewed_before ? "Yes" : "No"}
        </Box>
      ),
    },

    {
      field: "assigned_to",
      headerName: "Assigned To",
      width: 150,
      sortable: false,
      renderCell: ({ row }) => (
        <TextField
          autoComplete="off"
          value={row.reviewed_by ?? ""}
          disabled={value === 2}
          sx={{
            width: "100%",
            textTransform: "capitalize",
            "& .MuiInputBase-root": { padding: "5px 7px !important" },
            "& .MuiInputBase-input": { padding: "0 !important" },
          }}
          select
          variant="outlined"
          onChange={(e) =>
            setDialog({ open: true, row, newAssignee: e.target.value })
          }
        >
          {staffList?.map(({ full_name }, i) => (
            <MenuItem
              key={`${full_name}-${i}`}
              value={full_name}
              id={full_name}
              sx={{ textTransform: "capitalize" }}
            >
              {full_name}
            </MenuItem>
          ))}
        </TextField>
      ),
    },
    {
      field: "reviewed_by",
      headerName: "Reviewed By",
      sortable: true,
      width: 200,
      renderCell: ({ row }: any) => {
        const renderDate = (date: string) =>
          date ? moment(date).format("Do MMM YYYY, hh:mm A") : "";

        return (
          <Box display="flex" flexDirection="column" gap={1}>
            {row.reviewed_by && (
              <Box>
                <Typography variant="body2">
                  {row.action_taken
                    ? `${
                        row.action_taken === "no_change"
                          ? "No Changes marked"
                          : row.action_taken === "corrected"
                          ? "Correction done"
                          : row.action_taken
                      } by `
                    : state === "Assigned"
                    ? "Assigned to "
                    : "Reviewed by "}
                  <strong>{row.reviewed_by}</strong>
                </Typography>
                {row.reviewed_at && (
                  <Typography variant="caption" color="text.secondary">
                    on {renderDate(row.reviewed_at)}
                  </Typography>
                )}
              </Box>
            )}

            {/* Modified Info (only if different person or reviewed not available) */}
            {row.modified_by &&
              (!row.reviewed_by || row.reviewed_by !== row.modified_by) &&
              row.reported_by.full_name !== row.modified_by && (
                <Box>
                  {row.reviewed_by && (
                    <Divider sx={{ width: "100%", margin: "5px 0" }} />
                  )}
                  <Typography variant="body2">
                    Modified by <strong>{row.modified_by}</strong>
                  </Typography>
                  {row.modified_at && (
                    <Typography variant="caption" color="text.secondary">
                      on {renderDate(row.modified_at)}
                    </Typography>
                  )}
                </Box>
              )}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 153,
      sortable: false,
      renderCell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "5px", height: "fit-content" }}>
          {state !== "Archived" && state !== "Reviewed" && (
            <CustomContainedButton
              key="Review"
              otherProps={{
                variant: "contained",
                sx: { fontSize: "0.8rem !important", minWidth: "fit-content" },
                onClick: (e) => {
                  e.stopPropagation();
                  handleReview(row?.question, row);
                },
              }}
              content="Review"
            />
          )}

          <CustomPopover
            mt="5px !important"
            icon={moreRound}
            content={
              <Stack spacing={1} minWidth="75px">
                {state !== "Archived" && (
                  <CustomListItem
                    onClick={() =>
                      setDialog({ open: true, row, archive: true })
                    }
                    key="Archive"
                    alignItems="flex-start"
                    sx={{
                      display: "block",
                      color: globalColors.primary.black,
                      borderRadius: "7px",
                      transition: "background-color 0.3s ease",
                      "&:hover": {
                        background: globalColors.primary.lightGrey,
                        color: globalColors.primary.black,
                      },
                      mb: "5px",
                      p: "0",
                    }}
                  >
                    <ListItemButton
                      sx={{
                        maxHeight: "40px",
                        padding: "5px 8px !important",
                        background: "transparent !important",
                      }}
                    >
                      <ListItemText primary="Archive" />
                      <ArchiveOutlinedIcon />
                    </ListItemButton>
                  </CustomListItem>
                )}
                {row.review_status !== "pending" && (
                  <CustomListItem
                    onClick={() =>
                      setDialog({ open: true, row, pending: true })
                    }
                    key="pending"
                    alignItems="flex-start"
                    sx={{
                      display: "block",
                      color: globalColors.primary.black,
                      borderRadius: "7px",
                      transition: "background-color 0.3s ease",
                      "&:hover": {
                        background: globalColors.primary.lightGrey,
                        color: globalColors.primary.black,
                      },
                      mb: "5px",
                      p: "0",
                    }}
                  >
                    <ListItemButton
                      sx={{
                        maxHeight: "40px",
                        padding: "5px 8px !important",
                        background: "transparent !important",
                      }}
                    >
                      <ListItemText primary="Move to Pending   " />
                      <PendingActionsOutlinedIcon />
                    </ListItemButton>
                  </CustomListItem>
                )}
              </Stack>
            }
          />
        </Box>
      ),
    },
  ];
  const allStates = ["Pending", "Assigned", "Reviewed", "Archived"];
  const allDash = ["Pending", "Total Reported", "Reviewed"];

  const allTab = allStates.map((state, index) => ({
    id: index,
    tab: state,
    content: (
      // <DataTable
      //   columns={columns(state) as any}
      //   rows={(reportedQuestions.results ?? []).map(
      //     (s: { goal: { name: any } },index:number) => {
      //       return { ...s, goal_name: s.goal?.name??"",index:index };
      //     }
      //   )}
      // />
      <DataTable
        columns={columns(state) as any}
        rows={(reportedQuestions.results ?? []).map(
          (s: { goal: { name: any } }, index: number) => {
            return { ...s, goal_name: s.goal?.name ?? "", index: index };
          }
        )}
        loading={loadingInitial === true ? loadingInitial : globalLoading}
        pages={pages}
        reportedQuestions={reportedQuestions}
        filters={filters}
        setFilters={setFilters}
        onPageChange={onPageChange}
      />
    ),
  }));
  const debouncedSearch = React.useMemo(
    () =>
      debounce((val: string) => {
        // You can call API here instead of filtering locally
        if (val && val.toString().length > 0) {
          dispatch(
            fetchReportedBy({
              api: allApis.getReoprtedByList(val),
            })
          );
        } // Example: filter staff list by name if you want local filtering
        // setFilteredStaff(staffList.filter(s => s.full_name.toLowerCase().includes(val.toLowerCase())))
      }, 400), // 400ms delay
    []
  );
  const handleInputChange = React.useCallback(
    (_: any, value: string) => {
      if (
        masters.reportedBy.find(({ full_name_id }) => full_name_id === value) &&
        masters.reportedBy.find(({ full_name_id }) => full_name_id === value)
          ?.id
      ) {
      } else {
        setSearch(value);
        debouncedSearch(value);
      }
    },
    [debouncedSearch, masters.reportedBy]
  );
  return (
    <Stack
      height="calc(100% - 15px)"
      width="calc(100% - 16px)"
      direction={"row"}
      m="0 8px 15px"
      spacing={"8px"}
      // sx={{overflowX:"auto"}}
    >
      {openComfirm && (
        <ConfirmationDialog
          title={"You opened the review form for the question. Do you want to refresh the list ?"}
          content={
            <>
              {dialogs.row !== null && (
                <ReportedDetailsExpand
                  defaultOpen={true}
                  row={selectedRow}
                  reportid={selectedRow.id ?? ""}
                />
              )}
            </>
          }
          yesButtonText="Reload"
          noButtonText="No"
          open={openComfirm}
          onClose={() => {
            setConfirmation(false);
            setSelectedRow(null);
          }}
          onSubmit={async () => {
            onPageChange(1);
                setFilters((prev: any) => ({
                  ...prev,
                  refetch: !prev.refetch,
                }));
                setConfirmation(false);
                setSelectedRow(null);
          }}
        />
      )}
      {dialogs.open && (
        <ConfirmationDialog
          title={
            dialogs.pending
              ? "Move this question to Pending review ?"
              : dialogs.archive
              ? "Archive this question ?"
              : `Assign this reported question to ${dialogs.newAssignee} ${
                  dialogs.row.assigned_to
                    ? `from ${dialogs.row.assigned_to}`
                    : ""
                } ?`
          }
          content={
            <>
              {dialogs.row !== null && (
                <ReportedDetailsExpand
                  defaultOpen={true}
                  row={dialogs.row}
                  reportid={dialogs.row.id ?? ""}
                />
              )}
            </>
          }
          open={dialogs.open}
          onClose={() => {
            setDialog({});
          }}
          onSubmit={async () => {
            const requiredData = dialogs.pending
              ? { reviewed_by: "", review_status: "pending" }
              : dialogs.archive
              ? {
                  review_status: "archived",
                }
              : {
                  reviewed_by:
                    staffList.find((it) => it.name === dialogs.newAssignee)
                      ?.id ?? "",
                  review_status: "under_review",
                };

            try {
              await dispatch(
                assignStaff({ row: requiredData, id: dialogs.row?.id })
              ).unwrap(); // Unwrap the promise to handle errors
              // dispatch(fetchReportedQuestions({state: 'pending', page: 0})); // Refresh the reported questions list
            } catch (error) {
            } finally {
              setFilters((prev: any) =>
                dialogs.pending || dialogs.archive
                  ? {
                      ...prev,
                      refetch: !prev.refetch,
                    }
                  : {
                      ...prev,
                      onlyFetchTable: !prev.onlyFetchTable,
                    }
              );
              onPageChange(1);
              setDialog({});
            }
          }}
        />
      )}
      {openReportDialog !== false && (
        <ReportDialog report={openReportDialog} onClose={handleCloseDialog} />
      )}
      {openDialog && (
        <ReportedQuestionPreview
          handleDialogClose={handleDialogClose}
          selectedRow={selectedRow}
        />
      )}
      <GlobalBackdrop
        open={loadingInitial === true ? loadingInitial : globalLoading}
      />
      <Stack
        flex="8"
        sx={{
          borderRadius: "4px",
          width: "calc(100% - 20px)",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            p: "10px 10px",
            borderRadius: "4px",
            boxSizing: "border-box",
            marginBottom: "10px",
            border: "1px solid #e5e7eb",
            background: globalColors.primary.pureWhite,
          }}
        >
          <Box maxWidth={"230px"} mr="10px">
            {headerContent({
              text: ` List of Reported Questions`,
              sx: {
                p: "10px 0",
              },
              weight: "500",
              icons: [],
            })}
          </Box>
          <FilterPanel
            masters={masters}
            staffList={staffList}
            filters={filters}
            date={
              filters.start_date && filters.end_date
                ? formatDateRange({
                    startDate: filters.start_date,
                    endDate: filters.end_date,
                  })
                : ""
            }
            setFilters={setFilters}
            onPageChange={onPageChange}
            dFilter={dFilter}
            setSearch={setSearch}
            setLoading={setLoading}
            serach={serach}
            handleInputChange={(e: { target: { value: string } }) => {
              if (e && e.target) {
                handleInputChange(null, e.target.value);
              }
            }}
          />
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            boxSizing: "border-box",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
          {allDash.map((tab, i) => (
            <Box
              sx={{
                padding: "15px",
                width: "calc(33.33% - 10px)",
                boxSizing: "border-box",
                borderRadius: "4px",
                bgcolor: "white",
                // border: "1px solid #e5e7eb",
                background: globalColors.primary.pureWhite,
                border: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: 500,
              }}
              key={tab}
            >
              <Box>
                {" "}
                <span
                  style={{
                    color: "#4b5563",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                  }}
                >{`${tab} Questions`}</span>
                <br />
                <span
                  style={{
                    color:
                      i === 0 ? "#ea580c" : i === 1 ? "#2563eb" : "#16a34a",
                    fontSize: "1rem",
                  }}
                >
                  {countLoading
                    ? "..."
                    : reportedQuestionsCount[
                        i === 0
                          ? "pending_count"
                          : i === 1
                          ? "total_reported_count"
                          : "reviewed_count"
                      ] ?? 0}
                  {/* {i === 0
                    ? countLoading
                      ? ""
                      : ` + ${
                          reportedQuestionsCount["under_review_count"] ?? 0
                        } `
                    : ""} */}
                  {/* <span style={{ color: "rgb(75, 85, 99)", fontSize: "14px" }}>
                    {i === 0 ? (countLoading ? "" : `(assigned)`) : ""}
                  </span> */}
                </span>
                {/* <p
                  style={{
                    margin: "2px 0 0 0",
                    fontSize: "0.7rem",
                    color:
                      i === 0 ? "#ea580c" : i === 1 ? "#2563eb" : "#16a34a",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {i === 0 ? (
                    <WatchLaterIcon
                      style={{
                        height: "15px",
                        width: "15px",
                        marginRight: "5px",
                      }}
                    />
                  ) : i === 1 ? (
                    <ArrowUpward
                      style={{
                        height: "15px",
                        width: "15px",
                        marginRight: "5px",
                      }}
                    />
                  ) : (
                    <CheckCircleIcon
                      style={{
                        height: "15px",
                        width: "15px",
                        marginRight: "5px",
                      }}
                    />
                  )}
                  {i === 0
                    ? "Needs attention"
                    : i === 1
                    ? "12.5%"
                    : "Completed"}
                </p> */}
              </Box>
              <Box
                sx={{
                  bgcolor:
                    i === 0 ? "#ffedd5" : i === 1 ? "#dbeafe" : "#dcfce7",
                  borderRadius: "4px",
                  height: "40px",
                  width: "40px",
                  color: i === 0 ? "#ea580c" : i === 1 ? "#2563eb" : "#16a34a",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {i === 0 ? (
                  <HourglassTopTwoToneIcon
                    sx={{ height: "20px", width: "20px" }}
                  />
                ) : i === 1 ? (
                  <ReportProblemIcon sx={{ height: "20px", width: "20px" }} />
                ) : (
                  <svg
                    style={{ height: "30px", width: "30px" }}
                    className="w-6 h-6 text-green-600"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {/* first check */}
                    <path d="M6 12l2 2l4-4" />
                    {/* second check with a gap */}
                    <path d="M10 16l2 2l6-6" />
                  </svg>
                )}
              </Box>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            width: "100%",
            // height: "calc(100% - 169.33px)",
            // p: "10px 10px 0",
            flex: 8,
            overflow: "hidden",
            mt: "10px",
            borderRadius: "4px",
            boxSizing: "border-box",
            background: globalColors.primary.pureWhite,
            border: "1px solid #e5e7eb",
          }}
        >
          {
            <Box sx={{ height: "100%" }}>
              <CustomTab
                selected={allTab.find((it) => it.id === value)}
                tabs={allTab}
                onChange={(id: number) => {
                  handleChange(id);
                }}
                largeWidth={reportedQuestions.count > 90 ? true : false}
                badgeCount={{
                  [allTab.find((it) => it.id === value)?.tab ?? ""]: (
                    loadingInitial === true ? loadingInitial : globalLoading
                  )
                    ? ".."
                    : reportedQuestions.count,
                }}
              />
            </Box>
          }

          <AssignDialog
            staffList={staffList}
            selectedStaff={selectedStaff}
            handleStaffChange={handleStaffChange}
            row={selectedRow}
            open={openAssignDialog}
            onClose={handleCloseAssignDialog}
            onConfirm={handleConfirmAssign}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ContentFeedback;
